import * as theme from "../theme";

import Slider from "@mui/material/Slider";
import styled from "styled-components";

export default function RateZipSlider({
  range,
  min,
  max,
  value,
  handleChange,
  step,
}) {
  return (
    <>
      <MobileNumberContainer>
        <MobileNumberText>{range}</MobileNumberText>
      </MobileNumberContainer>
      <SliderContainer>
        <StyledSlider
          size="small"
          aria-label="Small"
          valueLabelDisplay="auto"
          min={min}
          max={max}
          value={value}
          onChange={handleChange}
          step={step}
        />
      </SliderContainer>
    </>
  );
}

const SliderContainer = styled.div`
  margin: 16px 0px;
  max-width: 450px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  @media (max-width: ${theme.mobile}) {
    width: 330px;
  }
`;

const StyledSlider = styled(Slider)`
  height: 0.75rem !important;

  .MuiSlider-track {
    color: ${theme.primary_light} !important;
  }
  /* .MuiSlider-rail {
    color: ${theme.grey} !important;
  } */
  .MuiSlider-thumb {
    color: ${theme.primary_light} !important;
    width: 2rem !important;
    height: 2rem !important;
  }

  @media (max-width: ${theme.mobile}) {
    width: 330px !important;
  }
`;

const MobileNumberContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 50px 0px 0px 0px;
`;

const MobileNumberText = styled.p`
  border: none;
  font-family: "Inter";
  font-style: normal;
  font-weight: 600;
  font-size: 24px;
  line-height: 32px;
  text-align: center;
  color: ${theme.primary_light};
  margin: 0px;
`;
